module.exports = __webpack_public_path__ + "img/image 25.7da63bd7.svg";